import React from "react";
import { useSearchParams, Navigate } from "react-router-dom";
import PeChapterViewer from "./PeChapterViewer";

const LtiResourcesPage: React.FC = () => {
  const [searchParams] = useSearchParams();

  const ltiTokenFromUrl = searchParams.get("ltik");
  const ltiToken = ltiTokenFromUrl ?? localStorage.getItem("ltiToken");

  const chapterId = searchParams.get("chapter_id");
  const tier = searchParams.get("tier");
  const lang = searchParams.get("lang");

  // Student launch path: chapter context present → render viewer
  if (chapterId && tier && lang) {
    return (
      <PeChapterViewer
        chapterId={chapterId}
        tier={tier}
        lang={lang}
        ltik={ltiToken}
      />
    );
  }

  // No chapter context: redirect to the PE chapter picker (deep-link setup flow,
  // or any stale Canvas link that lands here without chapter params)
  const pickerPath = ltiTokenFromUrl
    ? `/lti/chapter-picker?ltik=${encodeURIComponent(ltiTokenFromUrl)}`
    : "/lti/chapter-picker";

  return <Navigate to={pickerPath} replace />;
};

export default LtiResourcesPage;
